(function() {
  'use strict';
  angular.module('dso')
  .filter('groupColumn', function() {
    return function(input, row) {
      if ((!row.internalRow && !row.groupHeader) &&
       (row.entity.taxId === input || row.entity.centerId === input)) {
        return '';
      } else {
        if(input === null) return 'Null';
        return input;
      }
    };
  });
})();
